module.exports = __webpack_public_path__ + "0b98dcc4.png";